import React, { useRef, useCallback, useEffect } from 'react'
import styles from './Single.less'

import Btn from './Btn'
import Preview from './Preview'

const Video = ({ children, value, onChange, thumbnail, autoPreview, disabled, ...restProps }) => {
    const $this = useRef({
        value
    })

    $this.current.value = value

    const $uploader = useRef(null)

    useEffect(() => {
        return () => {
            const { value } = $this.current

            if (Array.isArray(value)) {
                value.forEach(v => v && v.uploadTask && v.uploadTask.abort())
            } else {
                value && value.uploadTask && value.uploadTask.abort()
            }
        }
    }, [])

    const sizeStyle = { width: `${thumbnail.width}px`, height: `${thumbnail.height}px` }

    const btnProps = {
        value,
        onChange,
        thumbnail,
        autoPreview,
        ...restProps
    }

    const handleSelect = useCallback(() => {
        $uploader.current && $uploader.current.select()
    }, [])

    const handleDelete = useCallback(() => {
        onChange(null)
    }, [onChange])

    return (
        <div className={styles.container} style={sizeStyle}>
            {value ? (
                <Preview
                    style={sizeStyle}
                    dataSource={{ ...value, type: 'video/mp4' }}
                    showProgress={autoPreview}
                    thumbnail={thumbnail}
                    onSelect={handleSelect}
                    onDelete={handleDelete}
                    disabled={disabled}
                />
            ) : (
                <Btn ref={$uploader} style={sizeStyle} thumbnail={thumbnail} {...btnProps} />
            )}
        </div>
    )
}

Video.defaultProps = {
    icon: 'video',
    accept: 'video/*',
    multiple: false,
    autoPreview: false,
    thumbnail: {
        // 缩略图配置项
        width: 202,
        height: 122,
        quality: 70,
        allowMagnify: true,
        crop: true,
        type: 'image/jpeg'
    }
}

export default Video
